<section class="page">

  <!-- 1. HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>

    <div class="hero__content">
      <div class="hero__kicker">
        <span class="kicker-dot"></span>
        <span>{{ 'home.roadmap.hero.kicker' | translate }}</span>
      </div>
      <h1 class="hero__title">{{ 'home.roadmap.hero.title' | translate }}</h1>
      <p class="hero__subtitle">{{ 'home.roadmap.hero.subtitle' | translate }}</p>

    </div>
  </header>

  <!-- 2. MAP -->
  <section class="section">
    <div class="map-card">
      <div class="map-card__head">
      </div>

      <div class="map-wrap">
        <svg class="map" [attr.viewBox]="'0 0 ' + mapWidth + ' ' + mapHeight" role="img"
          [attr.aria-label]="'home.roadmap.map.aria' | translate" preserveAspectRatio="xMidYMid meet">
          <g class="land-layer">
            @for (country of land; track country.code) {
            <path class="land" [class.land--live]="liveCodes.has(country.code)" [attr.d]="country.path">
              <title>{{ country.name }}</title>
            </path>
            }
          </g>

          <!-- backbone joining the live hubs -->
          <path class="backbone" [attr.d]="backbonePath" fill="none" />

          <!-- live hubs -->
          @for (node of liveNodes; track node.code) {
          <g class="hub">
            <circle class="hub__pulse" [attr.cx]="node.x" [attr.cy]="node.y" r="7" />
            <circle class="hub__core" [attr.cx]="node.x" [attr.cy]="node.y" r="6">
              <title>{{ node.country }} — {{ node.city }}</title>
            </circle>
            <text class="hub__label" [attr.x]="node.x + 12" [attr.y]="node.y - 6">{{ node.country }}</text>
            <text class="hub__city" [attr.x]="node.x + 12" [attr.y]="node.y + 8">{{ node.city }}</text>
          </g>
          }
        </svg>
      </div>

      <div class="map-stats">
        <div class="stat">
          <div class="stat__value">{{ liveCount }}</div>
          <div class="stat__label">{{ 'home.roadmap.map.statLive' | translate }}</div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat">
          <div class="stat__value">{{ totalCount }}</div>
          <div class="stat__label">{{ 'home.roadmap.map.statTotal' | translate }}</div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat">
          <div class="stat__value">EU</div>
          <div class="stat__label">{{ 'home.roadmap.map.statResidency' | translate }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- 3. MILESTONES -->
  <section class="section">
    <div class="milestones">
      <div class="milestones__track">
        @for (goal of milestones; track goal.city) {
        <div class="milestone" [class.milestone--live]="goal.live">
          <span class="milestone__dot"></span>
          <span class="milestone__city">{{ goal.i18n ? (goal.city | translate) : goal.city }}</span>
          @if (goal.country) {
          <span class="milestone__country">{{ goal.country }}</span>
          }
        </div>
        }
      </div>
    </div>
  </section>

  <!-- 4. WHY -->
  <section class="section">
    <div class="section__head">
      <div class="section__kicker">{{ 'home.roadmap.why.kicker' | translate }}</div>
      <h2 class="section__title">{{ 'home.roadmap.why.title' | translate }}</h2>
    </div>

    <div class="why-grid">
      <div class="why-card">
        <div class="why-card__head">
          <div class="card__icon-wrap card__icon-wrap--primary"><mat-icon>shield_lock</mat-icon></div>
          <h3>{{ 'home.roadmap.why.residency.title' | translate }}</h3>
        </div>
        <p>{{ 'home.roadmap.why.residency.description' | translate }}</p>
      </div>
      <div class="why-card">
        <div class="why-card__head">
          <div class="card__icon-wrap card__icon-wrap--secondary"><mat-icon>bolt</mat-icon></div>
          <h3>{{ 'home.roadmap.why.latency.title' | translate }}</h3>
        </div>
        <p>{{ 'home.roadmap.why.latency.description' | translate }}</p>
      </div>
      <div class="why-card">
        <div class="why-card__head">
          <div class="card__icon-wrap card__icon-wrap--tertiary"><mat-icon>verified_user</mat-icon></div>
          <h3>{{ 'home.roadmap.why.gdpr.title' | translate }}</h3>
        </div>
        <p>{{ 'home.roadmap.why.gdpr.description' | translate }}</p>
      </div>
    </div>
  </section>

  <!-- 5. FINAL CTA -->
  <section class="section">
    <div class="cta-banner">
      <div class="cta-banner__orb"></div>
      <h2 class="cta-banner__title">{{ 'home.roadmap.cta.title' | translate }}</h2>
      <p class="cta-banner__subtitle">{{ 'home.roadmap.cta.subtitle' | translate }}</p>
      <a mat-flat-button routerLink="/register" class="btn-primary btn-primary--lg">
        {{ 'home.roadmap.cta.button' | translate }}
      </a>
    </div>
  </section>

</section>